// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, retrieveToken } from "../../store/api";
import { PartnerListResponse } from "./types";

import * as partnerActions from "./partner.actions";

export function* getPartner(
  action: ReturnType<typeof partnerActions.getPartnerAsync.request>
) {
  try {
    const token: string = yield retrieveToken();
    const url = BASE_URL + 'partner';
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: PartnerListResponse = yield call(result.json.bind(result));
      yield put(partnerActions.getPartnerAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(partnerActions.getPartnerAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(partnerActions.getPartnerAsync.failure(parsed));
  }
}

export default function* partnerSagaGetPartner() {
  yield takeEvery(partnerActions.getPartnerAsync.request, getPartner);
}
